import { Box, Container, Grid } from '@mui/material';
import { MainContent } from 'src/layouts/main';
import { SparkWebLocationExperienceDetailsDto } from '../../../../../../libs/contracts/src/lib/spark/tenant/v1/experience/experience.dto';
import ExperienceDatePicker from '../experience-date-picker';
import ExperienceSlotsPicker from '../experience-slots-picker';
import ExperienceTickets from '../experience-tickets';
import ExperienceBookingNavBar from '../experience-booking-nav-bar';
import ExperienceDetails from '../experience-details';
import { LightboxGallery } from 'src/components/gallery/lightbox-gallery';

type Props = {
  experience: SparkWebLocationExperienceDetailsDto;
};

export default function ExperienceDetailsView({ experience }: Props) {
  return (
    <MainContent>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 3, md: 4 },
          mb: 10,
          p: 0,
        }}
      >
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              position: { xs: 'static', md: 'sticky' },
              top: { md: 'var(--layout-header-mobile-height)' },
              zIndex: { md: 2 },
              backgroundColor: { md: 'background.paper' },
              alignSelf: { md: 'flex-start' },
            }}
          >
            <LightboxGallery media={experience.media} variant="grid" />
          </Grid>

          <Grid item xs={12} md={6}>
            <ExperienceDetails experience={experience} />
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <ExperienceDatePicker
              latestBookingDate={experience.latestBookingDate}
            />
            <ExperienceSlotsPicker experience={experience} />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              position: { xs: 'static', md: 'sticky' },
              top: { md: 'var(--layout-header-mobile-height)' },
              zIndex: { md: 2 },
              backgroundColor: { md: 'background.paper' },
              alignSelf: { md: 'flex-start' },
            }}
          >
            <ExperienceTickets tickets={experience.tickets} />
          </Grid>
        </Grid>

        {/* Add padding to prevent content from being hidden behind the bottom bar */}
        <Box sx={{ height: 80 }} />
      </Container>

      <ExperienceBookingNavBar
        experienceTickets={experience.tickets}
        paymentMethods={experience.paymentMethods}
      />
    </MainContent>
  );
}
